import { useTranslation } from 'react-i18next'
import useAivatarDidMount from '../../../../../hooks/useAivatarDidMount'
import useOpenSelect from '../useOpenSelect'
import DressSelectContent from './DressSelectContent'

function DressSelect() {
  const { t } = useTranslation('project-option')
  const { component: OpenSelectRowComponent, isOpen } = useOpenSelect({
    title: t('의상 및 제스처'),
    order: 2,
  })

  /** Recoilds */

  /** Fetching */

  /** Life Cycle */
  useAivatarDidMount(() => {}, [])

  /** Events */

  /** Displays */

  return (
    <div className="shadow_1 flex w-full flex-col justify-between rounded-[24px] bg-white px-[14px] py-[20px]">
      {OpenSelectRowComponent}
      <DressSelectContent isOpen={isOpen} />
    </div>
  )
}
export default DressSelect
